<template>
  <SolutionPageLayout title="Data & Security" section="Outcomes">
    <p>
      Event data is sensitive: personal details, payment flows, attendance, and partner information all need to be handled with care.
    </p>
    <p>
      Entegy is designed with security and operational discipline in mind—so your team can focus on the event while the platform supports responsible data handling and access control.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
